import { render, staticRenderFns } from "./assetinfo.vue?vue&type=template&id=590c26bb"
import script from "./assetinfo.vue?vue&type=script&lang=js"
export * from "./assetinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports